<template>
  <div class="c-icon-badge" :class="color ? `c-icon-badge--${color}` : ''">
    <i :class="`fa-regular ${icon}`"></i>
  </div>
</template>

<script>
export default {
  props: {
    icon:  { type: String, required: true },
    color: { type: String, default: '' }, // green | purple | orange | teal | yellow | '' (default blue)
  },
};
</script>

<style lang="scss" scoped>
.c-icon-badge {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eef2ff;
  color: #5c7cfa;
  font-size: 1em;

  &--green  { background: #ebfbee; color: #40c057; }
  &--purple { background: #f3f0ff; color: #7950f2; }
  &--orange { background: #fff4e6; color: #f59f00; }
  &--teal   { background: #e6fcf5; color: #0ca678; }
  &--yellow { background: #fff8e1; color: #e6a817; }
}
</style>
